import Vue from 'vue'
import Router from 'vue-router'
//import Secured from '@/components/secured-loans/secured'
// import Unsecured from '@/components/unsecured-loans/un-secured'
// import Pos from '@/components/pos/pos'
// import ContactUs from '@/components/contact-us/contact-us'
// import FAQ from '@/components/faq/Faq'
// import Mission from '@/components/about-us/mission'
// import MediaandAwards from '@/components/new-media-awards/media-awards'
// import Blogs from '@/components/blogs'
// import Lifeatftcash from '@/components/life-at-ftcash'
// import Termsandconditions from '@/components/terms-conditions/terms-and-conditions'
// import Privacypolicy from '@/components/privacy-policy'
// import Apptermsandconditions from '@/components/app-terms-conditions/app-terms-conditions'

const Secured = () => import('@/components/secured-loans/secured');
const Unsecured = () => import('@/components/unsecured-loans/un-secured');
const Pos = () => import('@/components/pos/pos');
const ContactUs = () => import('@/components/contact-us/contact-us');
// const FAQ = () => import('@/components/faq/Faq');
const Mission = () => import('@/components/about-us/mission');
const MediaandAwards = () => import('@/components/new-media-awards/media-awards');
//const Blogs = () => import('@/components/blogs');
//const Lifeatftcash = () => import('@/components/life-at-ftcash');
const Termsandconditions = () => import('@/components/terms-conditions/terms-and-conditions');
const Privacypolicy = () => import('@/components/privacy-policy');
//const Apptermsandconditions = () => import('@/components/app-terms-conditions/app-terms-conditions');

Vue.use(Router)

export default new Router({
  base: '/', 
  routes: [
    {
      path: '/',
      name: 'unsecured',
      component: Unsecured,
      meta: {
        title: 'Unsecured Business Loan - Apply collateral-free business loan',
      }
      
    },
    { path: '/index.php', redirect: '/' },
    { path: '/index.html', redirect: '/' },
    { path: '/products.php', redirect: '/' },
    { path: '/features.php', redirect: '/' },
    { path: '/about.php', redirect: '/about' },
    { path: '/aboutus.php', redirect: '/about' },
    { path: '/awards.php', redirect: '/awards' },
    { path: '/contact-us.php', redirect: '/contact' },
    { path: '/privacy.php', redirect: '/privacypolicy' },
    { path: '/privacy-policy', redirect: '/privacypolicy' },
    { path: '/privacy-policy/', redirect: '/privacypolicy' },
    { path: '/terms_service.php', redirect: '/tnc' },
    { path: '/terms-of-service', redirect: '/tnc' },
    { path: '/terms-of-service/', redirect: '/tnc' },
    { path: '/loans', redirect: '/' },
    { path: '/digital-payments.php', redirect: '/pos' },
    { path: '/secured', redirect: '/secured-business-loan' },
    {
      path: '/secured-business-loan',
      name: 'secured-business-loan',
      component:  Secured,
      meta: {
        title: 'Secured Business Loan -  Apply Secured Loan For Small Businesses',
      }
    },
    {
      path: '/pos',
      name: 'pos',
      component: Pos,
      meta: {
        title: "ftcash's Point of Sale Machine - A Digital Payment Solutions",
      }
    },
    {
      path: '/contact',
      name: 'contactus',
      component: ContactUs,
      meta: {
        title: 'ftcash - Contact us',
      }
    },
    // {
    //   path: '/faq',
    //   name: 'faq',
    //   component: FAQ,
    //   meta: {
    //     title: "ftcash - Business Loan FAQ | Business Loan Questions",
        
    //   }
    // },
    {
      path: '/about',
      name: 'aboutus',
      component: Mission,
      meta: {
        title: 'About ftcash | Business Loans Providers',
      }
    },
    {
      path: '/awards',
      name: 'mediaandawards',
      component: MediaandAwards,
      meta: {
        title: 'ftcash - Media and Awards',
      }
    },
    // {
    //   path: '/blogs',
    //   name: 'blogs',
    //   component: Blogs,
    //   meta: {
    //     title: 'ftcash - Blogs',
    //   }
    // },
    // {
    //   path: '/careers',
    //   name: 'lifeatftcash',
    //   component: Lifeatftcash,
    //   meta: {
    //     title: 'ftcash - Careers',
    //   }
    // },
    {
      path: '/tnc',
      name: 'termsandconditions',
      component: Termsandconditions,
      meta: {
        title: 'ftcash - Terms and Conditions',
      }
    },
    {
      path: '/privacypolicy',
      name: 'privacypolicy',
      component: Privacypolicy,
      meta: {
        title: 'ftcash - Privacy Policy',
      }
    },
    // {
    //   path: '/apptnc',
    //   name: 'apptermsconditions',
    //   component: Apptermsandconditions,
    //   meta: {
    //     title: 'ftcash - Referral Terms and Conditions',
    //   }
    // },
    {
    path: '*',
    name: 'catchAll',
    component: Unsecured
    }

  ],
  mode: 'history', 
})




